import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoadingPrimaryColor: false,
  isLoadingTemplates: false,
  primaryColor: {},
  templates: {},
  hasError: false,
  error: '',
  sucessTemplate: false,
  sucessPrimaryColor: false,
  uploadErrors: [],
};

const structureDesignSlice = createSlice({
  name: 'structureDesign',
  initialState,
  reducers: {
    SET_TEMPLATE: (state, { payload }) => ({
      ...state,
      isLoadingTemplates: true,
      templates: payload.templates,
    }),
    GET_TEMPLATE: (state, { payload }) => ({
      ...state,
      isLoadingTemplates: true,
      templates: payload,
    }),
    SUCESS_TEMPLATE: (state, { payload }) => ({
      ...state,
      sucessTemplate: payload,
    }),
    GET_PRIMARY_COLOR: state => ({
      ...state,
      isLoadingPrimaryColor: true,
    }),
    SET_PRIMARY_COLOR: (state, { payload }) => ({
      ...state,
      primaryColor: payload,
      isLoadingPrimaryColor: true,
    }),
    SUCESS_PRIMARY_COLOR: (state, { payload }) => ({
      ...state,
      sucessPrimaryColor: payload,
    }),
    HAS_ERROR: (state, { payload }) => ({
      ...state,
      hasError: payload,
    }),
    ERROR: state => ({
      ...state,
      error: 'Algo inesperado aconteceu',
    }),
    SET_UPLOAD_ERRORS: (state, { payload }) => ({
      ...state,
      uploadErrors: payload,
      error: 'Erro ao fazer upload das imagens',
    }),
    CLEAN_ERRORS: state => ({
      ...state,
      error: '',
      uploadErrors: [],
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});
export const {
  SET_TEMPLATE,
  GET_TEMPLATE,
  SUCESS_TEMPLATE,
  GET_PRIMARY_COLOR,
  SET_PRIMARY_COLOR,
  SUCESS_PRIMARY_COLOR,
  HAS_ERROR,
  ERROR,
  SET_UPLOAD_ERRORS,
  RESET_STATE,
  CLEAN_ERRORS,
} = structureDesignSlice.actions;

export const structureDesignSliceSeletor = state => state.structureDesign;

export default structureDesignSlice.reducer;
